<template>
  <div>
    <div class="w3-container">
      <div class="headerGridCMS w3-hide-print">
        <div>
          <header>
            <h2>Frequently Asked Questions</h2>
          </header>
        </div>
        <div>
          <router-link to="/cms/faqs-detail" class="w3-button w3-teal w3-small w3-right vmiddle">
            <i class="fas fa-plus" style="margin-right:8px;"></i>New FAQ
          </router-link>
        </div>
      </div>
      <div class="inputCard">
        <header>FAQs</header>
        <div class="content">
          <div class="faqsContentGrid w3-padding-8" v-for="(faq, index) in state.siteData.content.faqs.items" :key="index">
            <div class="faqsName w3-padding-8"><b>{{faq.title}}</b></div>
            <div v-if="faq.text" class="faqsText w3-padding-8" v-html="faq.text"></div>
            <div class="buttons">
              <router-link tag="button" :to="'/cms/faqs-detail/' + faq.url" class="w3-button w3-small w3-teal">Edit</router-link>
              <button class="w3-button w3-small w3-red" @click="deleteFaq(faq.url)">Delete</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var dataStore = require('../../dataStore').default

export default {
  name: 'cmsfaqs',
  data() {
    return {
      state: dataStore.state
    }
  },
  methods: {
    saveContent() {
      this.saving = true
      dataStore.saveSiteData().then((res) => {
        this.saving = false
        if (res === 'success') {
          this.saved = true
          setTimeout(() => {
            this.saved = false
          }, 2000)
        }
      })
    },
    deleteFaq(url) {
      let itemIndex = this.state.siteData.content.faqs.items.findIndex(savedFaq => savedFaq.url === url)
      if (itemIndex > -1) {
        if (confirm('Really DELETE ' + this.state.siteData.content.faqs.items[itemIndex].title + '?')) {
          this.state.siteData.content.faqs.items.splice(itemIndex, 1)
          this.saveContent()
        }
      }
    }
  }
}
</script>

<style scoped>
  .faqsContentGrid {display:grid; grid-template-columns: 250px 1fr 130px; grid-gap: 8px; border-bottom:1px solid #ccc;}
  .faqsContentGrid:last-child {border-bottom:0;}
  .buttons {text-align: right;}
  .inputCard header {text-align: left; padding-left:12px;}
@media screen and (max-width:993px) {
  .faqsTitle {font-size:10pt;}
  .faqsMeta {font-size:10pt; font-family: 'Roboto', sans-serif;}
  .faqsGrid {display:grid; grid-template-columns: 125px 1fr; grid-gap: 8px;}
  .faqsContentGrid {grid-template-columns: 1fr;}
}
</style>



// WEBPACK FOOTER //
// src/components/cms/cmsFaqs.vue